import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import TopFieldContent from '../../../../../Components/Form/components/TopFieldContent';
import useFormName from '../../../../../Hooks/useFormName';
import ErrorMessage from '../../../../../Components/Form/components/ErrorMessage';
import CitizenshipSelect from './CitizenshipSelect';
import { SelectValue } from '../../../../../Components/Base/Select/Select';
import { TermItem } from '../../../../../graphql/graphql';

interface Props {
	name: string;
	label?: string;
	isRequired?: boolean;
	className?: string;
	onChange?: (value: SelectValue) => void;
	onLoad?: (citizenShips: TermItem[]) => void;
}

const CitizenshipSelectField: React.FC<Props> = ({
	name,
	label,
	className,
	isRequired,
	onLoad,
}) => {
	const { fieldName } = useFormName({ name });
	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
	});

	return (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<CitizenshipSelect {...field} onLoad={onLoad} />
			{error?.message && <ErrorMessage tx={error.message} />}
		</div>
	);
};

export default CitizenshipSelectField;
